module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cip-break",
    attrs: {
      "id": "copy"
    }
  }, [_c('a', {
    attrs: {
      "id": "pIV"
    }
  }), _vm._v("Published with assistance from the foundation established in memory of Philip Hamilton McMillan of the Class of 1894, Yale College.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Copyright © 2019 by Kathleen Day.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("This book may not be reproduced, in whole or in part, including illustrations, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press), without written permission from the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Yale University Press books may be purchased in quantity for educational, business, or promotional use. For information, please e-mail "), _c('a', {
    attrs: {
      "href": "mailto:sales.press@yale.edu"
    }
  }, [_vm._v("sales.press@yale.edu")]), _vm._v(" (U.S. office) or "), _c('a', {
    attrs: {
      "href": "mailto:sales@yaleup.co.uk"
    }
  }, [_vm._v("sales@yaleup.co.uk")]), _vm._v(" (U.K. office).")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_11.htm#chap11"
    }
  }, [_vm._v("Chapters 11")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/chapter_14.htm#chap14"
    }
  }, [_vm._v("14")]), _vm._v(" adapted in part from Kathleen Day, "), _c('i', [_vm._v("S & L Hell: The People and the Politics behind the $1 Trillion Savings and Loan Scandal")]), _vm._v(". Copyright © 1993 by Kathleen Day. Used by permission of W.W. Norton & Company, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Set in Times Roman type by IDS Infotech, Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Printed in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Library of Congress Control Number: 2018943787")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("ISBN 978-0-300-22332-3 (hardcover : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("This paper meets the requirements of ANSI/NISO Z39.48-1992")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("(Permanence of Paper).")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("10  9  8  7  6  5  4  3  2  1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 63
// module chunks = 0